<template>
	<div class="content">
		<h1 class="margin-bottom">Order diagnostics {{ getId() }}</h1>

		<Tabs :tabs="tabs" v-model="active_tab" class="margin-top large-margin-bottom" />

		<div v-show="active_tab == 'diagnostics'">
			<OrderDiagnostics :id="getId()" :autoload="true" :order="this.order" />
		</div>

		<div v-show="active_tab == 'matrix'">
			<OrderProductMatrix :id="getId()" :autoload="true" />
		</div>

		<div v-show="active_tab == 'events'">
			<EventViewer :resource="'order:' + getId()" :autoload="true" />
		</div>
	</div>
</template>

<script>
export default {
  data: () => ({
    active_tab: 'diagnostics',
    tabs: {
      diagnostics: {
        name: 'Diagnostics'
      },
      matrix: {
        name: 'Product matrix'
      },
      events: {
        name: 'Events'
      }
    }
  }),
  methods: {
    getId () {
      return this.$route.params.id
    }
  }
}
</script>
